import { z } from 'zod';
import { oaContentUserSchema } from './user.open-api.types';
import { oaClientContactLabelSchema } from './client.open-api.types';

export const oaTaskAssignedUserSchema = oaContentUserSchema.extend({
    labels: z.array(oaClientContactLabelSchema)
});
export type OACommentTaskAssignedUser = z.infer<typeof oaTaskAssignedUserSchema>;
